const view = "consumption-monitoring";

export const consumptionMonitoring = {
  view,
  title: `${view}/title`,
  subtitle: `${view}/subtitle`,
};
